// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__233A5","warning":"Banner_warning__2HTaD","error":"Banner_error__gxK_i","info":"Banner_info__3jmAK"};